import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import { ClockIcon, MessageIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

import { CenterActivity } from '../../../../../../lib/types/models/center-activity/center-activity'
import { isHostFamilyDayActivity } from '../../../../../../utils/constants/activity.constants'

type Props = {
  centerActivity: CenterActivity
  className?: string
}

const CenterActivityView = ({ className, centerActivity }: Props) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <div className="flex items-center gap-1">
        <Badge text={DateFormatter.DDDMYYYY(centerActivity.date)} />
        {!isHostFamilyDayActivity(centerActivity.activity) && (
          <Badge
            variant="warning"
            iconPosition="start"
            icon={<ClockIcon color={tailwindColors.secondary.DEFAULT} />}
            text={`${DateFormatter.getFormattedTime({
              hours: new Date(centerActivity.startingTime).getHours(),
              minutes: new Date(centerActivity.startingTime).getMinutes()
            })} - ${DateFormatter.getFormattedTime({
              hours: new Date(centerActivity.endingTime).getHours(),
              minutes: new Date(centerActivity.endingTime).getMinutes()
            })}`}
          />
        )}
      </div>
      <InnerBox className="bg-white-hover rounded flex flex-row items-center gap-2">
        <MessageIcon color={tailwindColors.secondary.DEFAULT} />
        {centerActivity.comment ? (
          <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
            {centerActivity.comment}
          </Typography>
        ) : (
          <Typography variant="label-medium" color={tailwindColors.grey.light.active}>
            Aucune information disponible
          </Typography>
        )}
      </InnerBox>
    </div>
  )
}

export default CenterActivityView
